function initListing(searchQuery, initialPage) {
    var numFilters = 0;

    // Listing app
    const Listing = Vue.createApp({
        data() {
            return {
                //defaults
                results: [],
                numResults: 0,
                numPages: 1,
                currentPage: initialPage,
                query: searchQuery
            };
        },
        methods: {
            fetchResults: function () {
                let t = this;
                const qs = `page=${t.currentPage}&q=${t.query}`;
                this.navigate(qs);
                if (numFilters++ !== 0) {
                    history.pushState({ qs: qs }, 'page', '?' + qs);
                }
                else {
                    history.replaceState({ qs: qs }, 'page', '?' + qs);
                }
            },
            navigate: function (qs) {
                let t = this;
                // get the results
                $.getJSON(`/umbraco/api/searchapi/getresults?${qs}`, function (data) {
                    t.results = data.results;
                    t.numResults = data.numResults;
                    t.numPages = data.numPages;
                    t.currentPage = data.currentPage;
                });
            },
            go: function (n) {
                // switch to page n
                this.currentPage = n;
                this.fetchResults();
            }
        },
        created: function () {
            this.fetchResults();
        }
    });
    const vm = Listing.mount('#listing');

    // back/forward buttons
    $(window).on("popstate", function () {
        if (history.state) {
            vm.navigate(history.state.qs);
        }
    });
}